import React from "react";
import { Link } from "react-router-dom";
import logo from "../../Resources/iconwhite.png";
import { useI18n } from "../../i18n/LanguageContext";
import {
  IconFacebook,
  IconInstagram,
  IconMapPin,
  IconWhatsapp,
} from "../../components/SocialIcons";
import "./Footer.scss";

export const Footer = () => {
  const { t } = useI18n();
  const encodeMensaje = encodeURIComponent(t("footer.waMessage"));

  return (
    <footer className="pie">
      <div className="pie__rrss">
        <ul>
          <li className="facebook">
            <a
              href="https://www.facebook.com/profile.php?id=100090508821462"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("footer.facebook")}
            >
              <IconFacebook label={t("footer.facebook")} />
            </a>
          </li>
          <li className="instagram">
            <a
              href="https://www.instagram.com/clinicapontepie/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("footer.instagram")}
            >
              <IconInstagram label={t("footer.instagram")} />
            </a>
          </li>
          <li className="whatsapp">
            <a
              href={`https://wa.me/640104088?text=${encodeMensaje}`}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("footer.whatsapp")}
            >
              <IconWhatsapp label={t("footer.whatsapp")} />
            </a>
          </li>
          <li className="maps">
            <a
              href="https://maps.app.goo.gl/7VWptoN9qV8JqJVu9"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={t("footer.maps")}
            >
              <IconMapPin label={t("footer.maps")} />
            </a>
          </li>
        </ul>
      </div>
      <div className="pie__otros">
        <span className="pie__tagline">{t("footer.tagline")}</span>
        <nav className="pie__legal" aria-label={t("footer.legalNav")}>
          <Link to="/privacidad">{t("footer.privacy")}</Link>
          <Link to="/aviso-legal">{t("footer.legal")}</Link>
          <Link to="/cookies">{t("footer.cookies")}</Link>
        </nav>
      </div>
      <div className="pie__logo">
        <img src={logo} width={75} height={75} alt={t("footer.logoAlt")} />
      </div>
    </footer>
  );
};
